"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Button_1 = require("@material-ui/core/Button");
var Grid_1 = require("@material-ui/core/Grid");
var withStyles_1 = require("@material-ui/styles/withStyles");
var ErrorBoundary_1 = require("src/ErrorBoundary");
var Forms_1 = require("src/Forms");
var CartSummary_1 = require("./CartSummary");
var PaymentFormFields_1 = require("./PaymentFormFields");
var styles_1 = require("./styles");
var PaymentForm = /** @class */ (function (_super) {
    __extends(PaymentForm, _super);
    function PaymentForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formRef = React.createRef();
        /**
         * Prvent form from submitting as html form, and send to event handler
         */
        _this.onSubmit = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var form, cvvInput, expirationDateInput, cardholderNameInput, cardNumberInput, cardData;
            return __generator(this, function (_a) {
                if (event) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                form = this.formRef.current;
                if (form === null) {
                    return [2 /*return*/, this.props.displayMessage('payment form ref not registerd to component', 'error')];
                }
                cvvInput = form.cvv;
                expirationDateInput = form.expirationDate;
                cardholderNameInput = form.cardholderName;
                cardNumberInput = form.number;
                if (cardNumberInput === null) {
                    this.props.displayMessage('card number input not registerd to component', 'error');
                    return [2 /*return*/];
                }
                if (cvvInput === null) {
                    this.props.displayMessage('cvv input not registerd to component', 'error');
                    return [2 /*return*/];
                }
                if (expirationDateInput === null) {
                    this.props.displayMessage('expiration date input not registerd to component', 'error');
                    return [2 /*return*/];
                }
                if (cardholderNameInput === null) {
                    this.props.displayMessage('cardholder name input not registerd to component', 'error');
                    return [2 /*return*/];
                }
                cardData = {
                    number: cardNumberInput.value,
                    cvv: cvvInput.value,
                    expirationDate: expirationDateInput.value,
                    cardholderName: cardholderNameInput.value,
                    options: {
                        validate: true
                    }
                };
                this.props.onSubmit(cardData);
                return [2 /*return*/];
            });
        }); };
        _this.onSubmitWithoutNonce = function (event) {
            event.preventDefault();
            _this.props.onSubmitWithoutNonce();
        };
        return _this;
    }
    PaymentForm.prototype.render = function () {
        var _a = this.props, classes = _a.classes, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.errors, errors = _c === void 0 ? {} : _c, cart = _a.cart;
        var paymentRequired = cart.total > 0;
        var fieldsDisabled = disabled || !paymentRequired;
        var onFormSubmit = paymentRequired ? this.onSubmit : this.onSubmitWithoutNonce;
        return (React.createElement(Grid_1.default, { container: true, className: this.props.classes.cartContainer },
            React.createElement(Grid_1.default, { direction: "row", container: true, justify: "space-around" },
                React.createElement("form", { onSubmit: onFormSubmit, ref: this.formRef, style: { display: 'flex' } },
                    React.createElement(Grid_1.default, { container: true, xs: 12, sm: 8, className: classes.cartGridColumn, direction: "column" },
                        React.createElement(PaymentFormFields_1.default, { disabled: fieldsDisabled, errors: errors })),
                    React.createElement(Button_1.default, { type: "submit", style: { display: 'none' } })),
                React.createElement(Grid_1.default, { container: true, className: classes.cartGridColumn, xs: 12, sm: 4, direction: "column" },
                    React.createElement(CartSummary_1.default, { cart: cart }),
                    React.createElement(Forms_1.RequiredFieldsNotice, null),
                    React.createElement(Button_1.default, { className: classes.checkoutButton, style: { marginTop: 0 }, variant: "contained", color: "primary", type: "submit", disabled: disabled, onClick: onFormSubmit, size: "large" }, "submit")))));
    };
    return PaymentForm;
}(React.Component));
var PaymentFormWithErrors = ErrorBoundary_1.withDisplayMessage(PaymentForm);
exports.default = withStyles_1.default(styles_1.default)(PaymentFormWithErrors);
